export const security = {
  'if-you-donot-have-patranomic': 'Если отчества нет, поставь прочерк',
  citizenship: 'Гражданство',
  'email-results': 'По результатам проверки на твою почту <strong>{userEmail}</strong> будет отправлено письмо',
  'store-manager': 'Директор магазина',
  'security-questionnaire': 'Внутренняя анкета',
  'acceptable-formats': 'Допустимые форматы — .jpeg, .jpg, .png, .pdf',
  'download-file-before-sending': 'Загрузите файл(ы) перед отправкой',
  'field-too-long': 'Максімальная даўжыня поля — 255 сімвалаў',
};
